import {createGlobalStyle} from 'styled-components';

// The embed script mounts its own container on body and has no unmount API, so it is hidden instead
export const HideSnakkChat = createGlobalStyle`
	.snakk-chat-container {
		display: none !important;
	}
`;

// Shows the script's welcome bubble as a compact tooltip on hover instead of a permanent, large greeting.
// Only while the script itself marks it visible (.snakk-visible), so it stays hidden when the chat window is open.
// $suppressed hides it after a click until the mouse leaves, so it doesn't pop up under the cursor when the chat closes.
export const SnakkChatWelcomeOnHover = createGlobalStyle<{$suppressed: boolean}>`
	.snakk-chat-container .snakk-chat-welcome {
		bottom: 64px;
		width: max-content;
		max-width: 240px;
		padding: 8px 12px;
		border-radius: 8px;
		pointer-events: none;
		opacity: 0 !important;
		visibility: hidden !important;
		transform: none !important;
	}

	${({$suppressed}) => !$suppressed && `
		.snakk-chat-container:hover .snakk-chat-welcome.snakk-visible {
			opacity: 1 !important;
			visibility: visible !important;
		}
	`}

	.snakk-chat-container .snakk-chat-welcome-title {
		font-size: 13px;
		margin-bottom: 2px;
	}

	.snakk-chat-container .snakk-chat-welcome-subtitle {
		font-size: 12px;
	}
`;

// Chat can't be used: dim the launcher (clicks are blocked in the component)
export const SnakkChatUnavailable = createGlobalStyle`
	.snakk-chat-container .snakk-chat-launcher {
		opacity: 0.5;
		cursor: not-allowed;
		transform: none !important;
	}
`;
